import {pullRequestDockedPanelWidthSettingPath} from '@github-ui/paths'
import {verifiedFetch} from '@github-ui/verified-fetch'

export async function updateDockedPanelWidth(width: number, owner: string, repo: string, pullNumber: number) {
  const formData = new FormData()
  formData.set('docked_panel_width', String(width))

  verifiedFetch(pullRequestDockedPanelWidthSettingPath({owner, repo, pullNumber}), {
    method: 'POST',
    body: formData,
    headers: {Accept: 'application/json'},
  })
}
